export enum ApiResource {
  API = "/api/v1",
  PANEL_API = "/panel-api/v1",
  ADMIN_API = "/admin-api/v1",
}
